import type { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useChartStyles = makeStyles((theme: Theme) => ({
	chartHeader: {
		backgroundColor: theme.palette.common.white,
		borderBottom: `1px solid ${theme.palette.divider}`,
		padding: theme.spacing(1),
		paddingLeft: theme.spacing(3),
		textAlign: "left",
		fontSize: 14,
		fontWeight: "bold",
		color: "black",
		fontFamily:
			'"Open Sans", "Lucida Grande", Arial, Verdana, Helvetica, sans-serif',
	},
}));
